var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, alertClasses, Collapse, IconButton, styled, } from '@mui/material';
import { useEffect, useState } from 'react';
import { BellIcon, CheckIcon, CloseIcon, InformationIcon } from '../../icons';
const StyledAlert = styled(Alert)(({ severity, theme }) => ({
    minHeight: 40,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 10,
    borderLeft: '6px solid',
    fontSize: 'unset',
    backgroundColor: severity === 'warning'
        ? theme.palette.warning.light
        : severity === 'error'
            ? theme.palette.error.light
            : severity === 'info'
                ? theme.palette.info.light
                : theme.palette.success.light,
    borderColor: severity === 'warning'
        ? theme.palette.warning.main
        : severity === 'error'
            ? theme.palette.error.main
            : severity === 'info'
                ? theme.palette.info.main
                : theme.palette.success.main,
    '& > *': {
        alignItems: 'center',
        display: 'flex',
        gap: 10,
    },
    [`& .${alertClasses.message}`]: {
        fontSize: theme.typography.caption.fontSize,
        flexWrap: 'wrap',
    },
    [`& .${alertClasses.action}`]: {
        alignItems: 'flex-start',
        paddingTop: 0,
    },
    [`& .${alertClasses.icon}`]: {
        fontSize: 24,
        marginRight: '9px',
    },
}));
/**
 * This component is intended to show an alert that will remain on the page until a user closes the alert.
 * This component can be left on the page and re-used for multiple alerts. Any changes to the content inside
 * the alert will cause a previously closed alert to re-open.
 * @returns
 */
function MidmarkInlineNotification(_a) {
    var { children, title, severity, forceClose, forceOpen, sx, onClose } = _a, props = __rest(_a, ["children", "title", "severity", "forceClose", "forceOpen", "sx", "onClose"]);
    const [open, setOpen] = useState(false);
    useEffect(() => {
        if (children && !forceClose) {
            setOpen(true);
        }
        else {
            setOpen(false);
        }
    }, [children, title, severity, forceClose, forceOpen]);
    const handleClose = () => {
        setOpen(false);
        onClose && onClose();
    };
    return (_jsx(Collapse, Object.assign({ in: open }, { children: _jsxs(StyledAlert, Object.assign({ "aria-hidden": !open, severity: severity, iconMapping: {
                error: _jsx(BellIcon, { color: "error", fontSize: "inherit" }),
                warning: _jsx(BellIcon, { color: "warning", fontSize: "inherit" }),
                success: _jsx(CheckIcon, { color: "success", fontSize: "inherit" }),
                info: _jsx(InformationIcon, { color: "info", fontSize: "inherit" }),
            }, action: !forceOpen && (_jsx(IconButton, Object.assign({ sx: { height: '100%' }, onClick: () => handleClose(), role: "button" }, { children: _jsx(CloseIcon, { sx: (theme) => ({
                        color: theme.palette.text.hint,
                        fontSize: '16px',
                    }) }) }))), sx: sx }, props, { children: [title && _jsx("b", { children: title }), children] })) })));
}
export default MidmarkInlineNotification;
